import React from "react";
import ProductPage from "./ProductPage";
import image from "../Images/product-heroes/task-hero.png";
import detailImage from "../Images/dashboards/employee-dashboard.png";

const product = {
  "id": "tasks",
  "title": "Task Management",
  "headline": "Clear priorities.",
  "accent": "Progress you can see.",
  "description": "Create, assign and track tasks in one shared workspace. Keep deadlines, updates and team conversations connected so everyone knows what comes next.",
  "checks": [
    "Clear task ownership",
    "Real-time collaboration",
    "Connected workflows"
  ],
  "badge": "Every task, moving forward",
  "imageAlt": "Illustration of a team member organizing tasks, priorities and deadlines",
  "summary": [
    {
      "icon": "file",
      "title": "Organized task planning",
      "text": "Keep assignments and deadlines clear."
    },
    {
      "icon": "people",
      "title": "Connected collaboration",
      "text": "Share comments, files and updates."
    },
    {
      "icon": "chart",
      "title": "Visible progress",
      "text": "Understand activity across your team."
    }
  ],
  "featuresTitle": "Keep daily work organized from start to finish",
  "featuresSubtitle": "Practical tools for planning, collaboration and follow-through.",
  "features": [
    {
      "title": "Task creation & assignment",
      "icon": "file",
      "text": "Give each task a clear owner and a deadline.",
      "points": [
        "Create and assign tasks",
        "Set deadlines and dependencies",
        "Organize work with drag-and-drop tools"
      ]
    },
    {
      "title": "Team collaboration",
      "icon": "people",
      "text": "Keep task discussions and supporting information together.",
      "points": [
        "Share comments and files",
        "Real-time task updates",
        "Team notifications"
      ]
    },
    {
      "title": "Workflow automation",
      "icon": "layers",
      "text": "Connect related work and simplify repeatable steps.",
      "points": [
        "Task dependencies",
        "Automate repetitive actions",
        "Organized workflow tracking"
      ]
    },
    {
      "title": "Time tracking",
      "icon": "clock",
      "text": "Understand the time your team spends on work.",
      "points": [
        "Time recorded against tasks",
        "Individual activity tracking",
        "Team performance reports"
      ]
    },
    {
      "title": "Mobile & cloud access",
      "icon": "mobile",
      "text": "Help teams stay connected wherever they work.",
      "points": [
        "Access tasks across devices",
        "Mobile app support",
        "Cloud synchronization"
      ]
    },
    {
      "title": "Progress & productivity",
      "icon": "chart",
      "text": "Use activity insights to keep your work moving.",
      "points": [
        "Task progress visibility",
        "Performance analytics",
        "Workload overview"
      ]
    }
  ],
  "detailImageAlt": "BillPunch employee dashboard displaying tasks, deadlines and work summary",
  "detailLabel": "Clarity for Every Team Member",
  "detailTitle": "Less chasing updates. More getting things done.",
  "detailText": "Make it easier for employees to see assigned tasks and upcoming deadlines. Keep progress visible to the team with shared updates and clear ownership.",
  "detailPoints": [
    "Keep task details and files together",
    "Share updates with your teammates",
    "Review individual and team activity"
  ],
  "workflowTitle": "From a new task to a completed goal",
  "steps": [
    [
      "Plan your work",
      "Create tasks and define the work to be done."
    ],
    [
      "Assign ownership",
      "Choose team members, deadlines and dependencies."
    ],
    [
      "Work together",
      "Share files, comments and progress updates."
    ],
    [
      "Track completion",
      "Review task progress and time spent."
    ]
  ],
  "cta": "Give your team a clearer path to done."
};
product.image = image;
product.detailImage = detailImage;

const Taskmanagement = () => <ProductPage product={product} />;
export default Taskmanagement;
